module.exports = __webpack_public_path__ + "img/LikesIcon.b93934b6.svg";